import React from "react";

export default function Faqs2({ faqTitle, allFaqs, groupKey, onHomePage = false }) {
  const faqItems = Array.isArray(allFaqs) ? allFaqs : [];
  const wrapperId = `wrapper-faq-${groupKey || "default"}`;

  return (
    <>
      <div className="tf-faq mt-30">
        {/* <h3 className="fw-8 text-left title">{faqTitle}</h3> */}
        <h5 className="mb-16 text-black-2 text-center" style={onHomePage ? { fontWeight: "800", fontSize: "26px", textAlign: "left !important" } : { fontWeight: "800", fontSize: "26px" }}>
          {faqTitle}
        </h5>
        <ul className="box-faq" id={wrapperId}>
          {faqItems.map((faq, index) => {
            const accordionId = `accordion-faq-${groupKey || "default"}-${faq?.FAQId || faq?.Id || index}`;
            const isFirst = index === 0;
            const question = faq?.Question || faq?.Title || "";
            const answer = faq?.Answer || faq?.Description || "";

            return (
              <li className="faq-item" key={faq?.FAQId || faq?.Id || index}>
                <a
                  href={`#${accordionId}`}
                  className={`faq-header${isFirst ? "" : " collapsed"}`}
                  data-bs-toggle="collapse"
                  aria-expanded={isFirst ? "true" : "false"}
                  aria-controls={accordionId}
                >
                  {question}
                </a>
                <div
                  id={accordionId}
                  className={` collapse${isFirst ? " show" : ""}`}
                  data-bs-parent={`#${wrapperId}`}
                >
                  <p className="faq-body blog-description-content"
                    dangerouslySetInnerHTML={{
                      __html: answer,
                    }}
                  ></p>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
}
